'use client';

import { useEffect, useRef, useState } from 'react';

// 플립 완주 보장 훅.
// 부모가 주는 목표 상태(target: hover/탭 의도)를 그대로 따라가되, 애니메이션이 진행 중이면
// 반대 입력을 무시하고 현재 회전을 끝까지 마친 뒤(onComplete) 최신 목표를 반영한다.
// → 회전 도중 마우스가 들락거려도 중간에 되돌아오지 않고 항상 한 면까지 완주한다.
export function useDeferredFlip(target: boolean) {
  // 실제로 화면에 반영되는(애니메이션 대상) 플립 상태
  const [flip, setFlip] = useState(target);
  // 애니메이션 진행 중 여부(진행 중이면 새 입력을 큐잉만 하고 반영은 미룸)
  const animating = useRef(false);
  // 부모가 마지막으로 원한 목표(완주 후 이 값으로 따라잡는다)
  const desired = useRef(target);

  useEffect(() => {
    desired.current = target;
    // 정지 상태에서 목표가 바뀌면 즉시 회전 시작
    if (!animating.current && target !== flip) {
      animating.current = true;
      setFlip(target);
    }
  }, [target, flip]);

  // 회전 완주 시점: 그새 목표가 또 바뀌었으면 이어서 완주 반영
  const onComplete = () => {
    animating.current = false;
    if (desired.current !== flip) {
      animating.current = true;
      setFlip(desired.current);
    }
  };

  return { flip, onComplete };
}
